module.exports = __webpack_public_path__ + "03_short_black.cc3b6019.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/03_short_black.png
// module id = Sf4A
// module chunks = 0